import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { CheckIcon, ErrorIcon, InfoIcon, CloseIcon } from './Icons';

/**
 * Universal Web3 Toast Notification
 */
export interface ToastProps {
  message: string;
  type?: 'success' | 'error' | 'info';
  onClose?: () => void;
  duration?: number;
}

export function Toast({ message, type = 'info', onClose, duration = 4000 }: ToastProps) {
  useEffect(() => {
    if (!onClose || duration <= 0) return;
    const timer = setTimeout(() => {
      onClose();
    }, duration);
    return () => clearTimeout(timer);
  }, [onClose, duration]);

  const toastContent = (
    <div className={`toast toast-${type}`} role="alert" aria-live="polite">
      <div className="toast-content">
        <div className="toast-icon">
          {type === 'success' ? (
            <CheckIcon size={18} color="#10b981" />
          ) : type === 'error' ? (
            <ErrorIcon size={18} color="#ef4444" />
          ) : (
            <InfoIcon size={18} color="#3b82f6" />
          )}
        </div>
        <span className="toast-message">{message}</span>
        {onClose && (
          <button className="toast-close" onClick={onClose} aria-label="Close notification">
            <CloseIcon size={14} />
          </button>
        )}
      </div>
    </div>
  );

  return createPortal(toastContent, document.body);
}

export default Toast;
